import { Loader } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

const LazyPAYGPolicy = () => (
  <Loadable
    Loader={
      <div className="w-full h-screen flex justify-center py-24">
        <Loader />
      </div>
    }
    module={() =>
      import(/* webpackChunkName: "legal-payg-policy" */ './PAYGPolicy')
    }
  />
);

export default LazyPAYGPolicy;
